import $ from 'jquery';
import Util from "./utils";

// Custom abide validator for password fields
Foundation.Abide.defaults.validators['password_strength'] = checkPasswordComplexity;

// Conditionally set password toggle functionality
var passwordInput = document.getElementById('password');
if (passwordInput) {
    togglePassword(passwordInput);
}

var confirmInput = document.getElementById('confirm-password');
if (confirmInput) {
    togglePassword(confirmInput);
}

var azureCreatePassword = document.getElementById('newPassword');
if (azureCreatePassword) {
    togglePassword(azureCreatePassword);
}

var azureCreatePasswordConfirm = document.getElementById('reenterPassword');
if (azureCreatePasswordConfirm) {
    togglePassword(azureCreatePasswordConfirm);
}

$(function(){
    // Init Reset Password Landing page if we are on that page
    var passwordResetLanding = $(".reset-password-landing-form");
    if(passwordResetLanding && passwordResetLanding.length > 0) {
        initPasswordResetLandingForm();
    }

    var passwordEmailVerification = $("#verification-link-expired-form");
    if( passwordEmailVerification && passwordEmailVerification.length > 0) {
        initPasswordResetEmailVerificationExpiredForm();
    }

    var passwordResetPage = $("#password-confirmation-form");
    if( passwordResetPage && passwordResetPage.length > 0 ){
        initPasswordResetForm();
    }
});

/**
 * Check password complexity for the specified input element
 * @param {*} $el 
 * @returns 
 */
function checkPasswordComplexity($el) {
    const UPPERCASE_LETTERS_REGEX = /[A-Z]/;
    const LOWERCASE_LETTERS_REGEX = /[a-z]/;
    const NUMBERS_REGEX = /[0-9]/;
    const CHARACTERS_REGEX = /[\@\#\$\%\^\&\*\–\_\!\+\=[\]\{\}\|\\:\‘\,\.\?\/\`\~\”\(\)\;]/;
    const PW_MIN_LENGTH = 8;
    const PW_MAX_LENGTH = 64;
    let count = 0;

    var string = $($el).val();

    if (UPPERCASE_LETTERS_REGEX.test(string)) {
        count++;
    }

    if (LOWERCASE_LETTERS_REGEX.test(string)) {
        count++;
    }

    if (NUMBERS_REGEX.test(string)) {
        count++;
    }

    if (CHARACTERS_REGEX.test(string)) {
        count++;
    }

    if (string != '') {
        if (count >= 3 && string.length >= PW_MIN_LENGTH && string.length <= PW_MAX_LENGTH) {
            return true;
        }
        else {
            $('[data-form-error-for="password"]').html('Password does not meet requirements');
            return false;
        }
    } else {
        $('[data-form-error-for="password"]').html('Password is required');
        return false;
    }
}

// Dynamically add password toggle to password fields
function togglePassword(element) {
    var togglePasswordBtn = document.createElement('button', ['type', 'button']);
    togglePasswordBtn.innerHTML = '<span class="show-for-sr">Toggle Password</span>';
    togglePasswordBtn.setAttribute('type', 'button');
    togglePasswordBtn.classList.add('toggle-password');
    togglePasswordBtn.classList.add('toggle-password_view');

    var inputWrapper = $(element).closest('div');
    $(inputWrapper).css('position', 'relative');

    // Position toggle for MVC forms
    if ($(inputWrapper).hasClass('input-group')) {
        $(togglePasswordBtn).insertAfter($(element).closest('div > label'));
    }

    // Position toggle for SING IN Azure form
    if ($(inputWrapper).hasClass('entry-item')) {
        $(togglePasswordBtn).insertAfter($(element).closest('div > input'));
    }

    // Position toggle for CREATE ACCOUNT Azure form
    if ($(inputWrapper).hasClass('attrEntry')) {
        $(togglePasswordBtn).insertAfter($(element).closest('div > input'));
    }

    togglePasswordBtn.addEventListener('click', function (e) {
        e.preventDefault();

        if (element.getAttribute('type') == 'password') {
            element.setAttribute('type', 'text');
            togglePasswordBtn.classList.remove('toggle-password_view');
            togglePasswordBtn.classList.add('toggle-password_hide');
        } else {
            element.setAttribute('type', 'password');
            togglePasswordBtn.classList.remove('toggle-password_hide');
            togglePasswordBtn.classList.add('toggle-password_view');
        }
    });
}

/**
 * Sets up JS needed for Reset Password Landing page to work
 */
function initPasswordResetLandingForm(){
    let resetPasswordForm = $("#reset-password-form");
    resetPasswordForm.on("submit", function (e) {
        e.preventDefault();

        // Reset error messaging
        $(".form-status").hide();
        $(".form-status").removeClass("form-status_error form-status_success");
        $(".form-status p").html("");

        // Get email from form
        var email = $(this).find("#email").val();
        // Get Anti-CSRF token
        var csrfToken = $("[name='__RequestVerificationToken']").val();

        //Retreieve the communities of the given market area
        $.ajax("/acct/passwordreset/landingformsubmit",
        {
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify({
                Email: email
            }),
            beforeSend: function (request) {
                // Add CSRF token to the header
                request.setRequestHeader("__RequestVerificationToken", csrfToken);
            },
            success: function (response) {
                let status = response.Status;

                if (status === "error") {
                    $(".form-status").addClass("form-status_error");
                    $(".form-status p").html(response.ErrorMessage);
                    $(".form-status").show();
                }
                else {
                    $(".form-status").addClass("form-status_success");
                    $(".form-status").html("");
                    $(".form-status").hide();

                    window.location = "/acct/passwordreset/confirmemailaddress";
                }
            },
            error: function (error) {
                // user attempted to inject malicious code
                if (error.responseText.indexOf("A potentially dangerous Request.Form value was detected from the client") >= 0){
                    $(".form-status").addClass("form-status_error");
                    $(".form-status p").html("We were unable to find an account with the information provided. Please try again or create a new account.");
                    $(".form-status").show();
                }
                else {
                    $(".form-status").addClass("form-status_error");
                    $(".form-status p").html("Unexpected error occured. Please try again.");
                    $(".form-status").show();
                }
                
            }
        })
    });
}

/**
 * Sets up JS needed for Password Reset Email Verificaiton Failed page to work
 */
 function initPasswordResetEmailVerificationExpiredForm(){
    let verificationLinkExpiredForm = $("#verification-link-expired-form");
    verificationLinkExpiredForm.on("submit", function (e) {
        e.preventDefault();

        // Reset error messaging
        verificationLinkExpiredForm.find(".form-status").removeClass("is-visible");
        verificationLinkExpiredForm.find(".form-status").removeClass("form-status_error form-status_success");
        verificationLinkExpiredForm.find(".form-status p").html("");

        // Get original reset token from query
        var queryParams = Util.getUrlParameters();
        var verificationToken = queryParams["verificationToken"];
        // Get Anti-CSRF token
        var csrfToken = $("[name='__RequestVerificationToken']").val();

        //Retreieve the communities of the given market area
        $.ajax("/acct/passwordreset/verificationlinkexpiredformsubmit",
        {
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify({
                VerificationToken: verificationToken
            }),
            beforeSend: function (request) {
                // Add CSRF token to the header
                request.setRequestHeader("__RequestVerificationToken", csrfToken);
            },
            success: function (response) {
                let status = response.Status;

                if (status === "error") {
                    verificationLinkExpiredForm.find(".form-status").addClass("form-status_error");
                    verificationLinkExpiredForm.find(".form-status p").html(response.ErrorMessage);
                }
                else {
                    verificationLinkExpiredForm.find(".form-status").addClass("form-status_success");
                    verificationLinkExpiredForm.find(".form-status p").html("Successfully resent email verification link.");
                }
                
                verificationLinkExpiredForm.find(".form-status").show();
            },
            error: function (error) {
                verificationLinkExpiredForm.find(".form-status").addClass("form-status_error");
                verificationLinkExpiredForm.find(".form-status p").html("Unexpected error occured. Please try again.");
                verificationLinkExpiredForm.find(".form-status").show();
            }
        })
    });
}

/**
 * Sets up JS needed for Reset Password page to work
 */
 function initPasswordResetForm(){
    let passwordResetForm = $("#password-confirmation-form");
    passwordResetForm.on("submit", function (e) {
        e.preventDefault();

        // Reset error messaging
        $(".form-status").hide();
        $(".form-status").removeClass("form-status_error form-status_success");
        $(".form-status p").html("");

        // Get original reset token from query
        var queryParams = Util.getUrlParameters();
        var verificationToken = queryParams["verificationToken"];
        // Get Anti-CSRF token
        var csrfToken = $("[name='__RequestVerificationToken']").val();
        // Get password
        var password = $("#password").val();
        var confirmPassword = $("#confirm-password").val();

        //Retreieve the communities of the given market area
        $.ajax("/acct/passwordreset/resetformsubmit",
        {
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify({
                Password: password,
                ConfirmPassword: confirmPassword,
                VerificationToken: verificationToken
            }),
            beforeSend: function (request) {
                // Add CSRF token to the header
                request.setRequestHeader("__RequestVerificationToken", csrfToken);
            },
            success: function (response) {
                let status = response.Status;

                if (status === "error") {
                    $(".form-status").addClass("form-status_error");
                    $(".form-status p").html(response.ErrorMessage);
                    $(".form-status").show();
                }
                else {
                    $(".form-status").addClass("form-status_success");
                    $(".form-status p").html("");
                    $(".form-status").hide();
                    window.location = "/acct/passwordreset/success";
                }
            },
            error: function (error) {
                // user attempted to inject malicious code via password fields
                if (error.responseText.indexOf("A potentially dangerous Request.Form value was detected from the client") >= 0){
                    $(".form-status").addClass("form-status_error");
                    $(".form-status p").html("The specified password does not comply with password complexity requirements. Please provide a different password.");
                    $(".form-status").show();
                }
                else {
                    $(".form-status").addClass("form-status_error");
                    $(".form-status p").html("Unexpected error occured. Please try again.");
                    $(".form-status").show();
                }
            }
        })
    });
}
